import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '@/features/account-management/account.navigator';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';
import { UpdateMobileNoMain } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoMain';
import { UpdateMobileNoConfirm } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoConfirm';
import { UpdateMobileNoPlaced } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoPlaced';
import { UpdateMobileNoStackParamList, UpdateMobileNoStackRoutes } from '@/features/account-management/screens/update-mobile-no/type';

const UpdateMobileNoStack = createNativeStackNavigator<UpdateMobileNoStackParamList>();

export const UpdateMobileNoNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.UpdateMobileNo>> = ({
  route
}) => {
  const { func, refresh, record, onChangeView } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <UpdateMobileNoStack.Navigator
          initialRouteName={UpdateMobileNoStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <UpdateMobileNoStack.Screen
            name={UpdateMobileNoStackRoutes.Main}
            component={UpdateMobileNoMain}
            initialParams={{ onLayout, onData, onReturnData, func, refresh, record }}
            options={{ headerShown: false }}
          />
          <UpdateMobileNoStack.Screen
            name={UpdateMobileNoStackRoutes.Confirm}
            component={UpdateMobileNoConfirm}
            initialParams={{ onLayout, data, onReturnData, func, refresh, onChangeView, record }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <UpdateMobileNoStack.Screen
            name={UpdateMobileNoStackRoutes.Placed}
            component={UpdateMobileNoPlaced}
            initialParams={{ onLayout, data, returnData, record, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </UpdateMobileNoStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
